import {
  Box,
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  withStyles,
  withWidth,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import React from "react";
import { confirmable, createConfirmation } from "react-confirm";
import QrReader from "react-qr-reader";
import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import { handleError } from "../../../components/Utils/Utils";
import OrderService from "../../../Services/OrderService";
import "../style.css";
import { formatCurrency } from "../../../components/Utils/Currency";
import {
  StyledTable,
  StyledTableCellBodyBold,
  StyledTableRow,
} from "../../../components/CustomStyles/CustomTable";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const Form = (props) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [qrString, setQRString] = React.useState(null);
  const [transaction, setTransaction] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [updating, setUpdating] = React.useState(false);
  const [updated, setUpdated] = React.useState(false);
  const [error, setError] = React.useState("");

  const bottomDiv = React.useRef();

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const scrollToBottom = () => {
    if (bottomDiv && bottomDiv.current) {
      bottomDiv.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleScan = (data) => {
    if (data !== qrString) {
      if (data !== null) {
        setQRString(data);
        setLoading(true);
        setUpdated(false);
        OrderService.getTransaction(data)
          .then((response) => {
            setLoading(false);
            const transaction = response.data;

            if (
              transaction?.orders[0]?.tenant?.property?.id ===
              user?.operational?.id
            ) {
              setTransaction(transaction);
            } else {
              setTransaction("");
              handleError("You don't have access to this transaction data !!!");
            }
          })
          .catch((error) => {
            setLoading(false);
            setTransaction("");
            handleError(error);
          });
      }
    }
  };

  const handleUpdateProgress = () => {
    setUpdating(true);
    const id = transaction ? transaction?.id : "0";
    let params = [
      {
        op: "replace",
        path: "/complete",
        value: true,
      },
    ];

    if (
      transaction.delivery &&
      transaction.delivery.delivery_status === "delivering"
    ) {
      params.push({
        op: "replace",
        path: "/delivery/delivery_status",
        value: "complete",
      });
    }

    OrderService.patchTransactionData(id, params)
      .then((response) => {
        setUpdating(false);
        setUpdated(true);
      })
      .catch((error) => {
        setUpdating(false);
        setUpdated(true);
        setError(error);
      });
  };

  const handleOnError = (err) => {
    handleError(err);
  };

  React.useEffect(scrollToBottom, [transaction]);

  return (
    <CustomizedDialogs
      disableBackdropClick
      maxWidth={false}
      fullScreen={true}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent classes={{ root: classes.content }} dividers>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-evenly"
        >
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <QrReader
              delay={100}
              showViewFinder={false}
              onError={handleOnError}
              onScan={handleScan}
              style={{ width: "100%" }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="flex-start"
          justify="space-evenly"
        >
          {loading && (
            <Grid item xs={6}>
              <div
                style={{
                  width: "100%",
                  height: "50vh",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "20px auto",
                }}
              >
                <CircularProgress />
                <span style={{ marginTop: 10 }}>Search transaction data</span>
              </div>
            </Grid>
          )}
          {!loading && (
            <Grid
              item
              xs={12}
              sm={6}
              md={6}
              lg={6}
              xl={6}
              style={{ paddingLeft: 12 }}
            >
              {transaction && (
                <div>
                  {updated && !error && (
                    <Alert severity="success">Success Update Progress</Alert>
                  )}
                  {updated && error && (
                    <Alert severity="error">{error || ""}</Alert>
                  )}

                  {((!transaction?.complete &&
                    parseInt(transaction?.pickup?.id) > 0) ||
                    (!transaction?.complete &&
                      parseInt(transaction?.delivery?.id) > 0 &&
                      transaction?.delivery?.delivery_status ===
                        "delivering")) && (
                    <div>
                      <List style={{ width: "100%" }}>
                        <ListItem>
                          <ListItemText
                            primary={transaction?.unique_id}
                            secondary="Transaction Code"
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <ListItemText
                            primary={transaction?.user?.name}
                            secondary="Customer Name"
                          />
                        </ListItem>
                        <Divider />
                        <ListItem>
                          <ListItemText
                            primary={
                              transaction?.orders[0]?.tenant?.property?.name
                            }
                            secondary="Mall"
                          />
                        </ListItem>
                        <Divider />
                        {transaction?.delivery?.id > 0 &&
                        transaction?.delivery?.delivery_status ===
                          "delivering" ? (
                          <>
                            <ListItem>
                              <ListItemText
                                primary={transaction?.delivery?.consignee_phone}
                                secondary="Consignee Phone"
                              />
                            </ListItem>
                            <Divider />
                            <ListItem>
                              <ListItemText
                                primary={
                                  transaction?.delivery?.consignee_address
                                }
                                secondary="Consignee Address"
                              />
                            </ListItem>
                          </>
                        ) : (
                          <ListItem>
                            <ListItemText
                              primary={transaction?.pickup?.name}
                              secondary="Pickup Point"
                            />
                          </ListItem>
                        )}
                      </List>
                      {transaction?.orders?.map((row, key) => {
                        return (
                          <div key={key}>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                              }}
                            >
                              <img
                                src={row?.tenant?.logo?.square}
                                alt={row?.tenant?.name}
                                style={{ width: 50, height: 50 }}
                              />
                              <span
                                style={{
                                  fontSize: 14,
                                  fontWeight: "bold",
                                  marginLeft: 10,
                                }}
                              >
                                {row?.tenant?.name}
                              </span>
                            </div>
                            <Box
                              margin={1}
                              style={{
                                width: "100%",
                                maxWidth: "100%",
                                overflowX: "scroll",
                              }}
                            >
                              <StyledTable
                                size="small"
                                aria-label="detail order"
                              >
                                <TableHead>
                                  <StyledTableRow>
                                    <StyledTableCell width="80%">
                                      Item
                                    </StyledTableCell>
                                    <StyledTableCell align="right">
                                      Price
                                    </StyledTableCell>
                                  </StyledTableRow>
                                </TableHead>
                                <TableBody>
                                  {row?.items
                                    ? row?.items.map((item, i) => {
                                        return (
                                          <StyledTableRow key={i}>
                                            <StyledTableCell>
                                              {item.qty} x ({item.name || ""})
                                              {item.note && (
                                                <React.Fragment>
                                                  <br />
                                                  <span
                                                    style={{
                                                      fontStyle: "italic",
                                                      lineHeight: 2,
                                                    }}
                                                  >
                                                    {item.note}
                                                  </span>
                                                </React.Fragment>
                                              )}
                                            </StyledTableCell>
                                            <StyledTableCell align="right">
                                              {formatCurrency(
                                                row?.tenant?.property?.currency,
                                                (
                                                  item.qty *
                                                  (item.discounted_price
                                                    ? item.discounted_price
                                                    : item.price.value)
                                                ).toString()
                                              )}
                                            </StyledTableCell>
                                          </StyledTableRow>
                                        );
                                      })
                                    : ""}
                                  <StyledTableRow>
                                    <StyledTableCellBodyBold>
                                      Service ({row?.service_charge_percentage}
                                      %)
                                    </StyledTableCellBodyBold>
                                    <StyledTableCellBodyBold align="right">
                                      {formatCurrency(
                                        row?.tenant?.property?.currency,
                                        row?.service_charge_amount.toString()
                                      )}
                                    </StyledTableCellBodyBold>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCellBodyBold>
                                      Tax ({row?.tax_charge_percentage}
                                      %)
                                    </StyledTableCellBodyBold>
                                    <StyledTableCellBodyBold align="right">
                                      {formatCurrency(
                                        row?.tenant?.property?.currency,
                                        row?.tax_charge_amount.toString()
                                      )}
                                    </StyledTableCellBodyBold>
                                  </StyledTableRow>
                                  <StyledTableRow>
                                    <StyledTableCellBodyBold>
                                      Sub Total
                                    </StyledTableCellBodyBold>
                                    <StyledTableCellBodyBold align="right">
                                      {formatCurrency(
                                        row?.tenant?.property?.currency,
                                        (row?.sub_total_amount).toString()
                                      )}
                                    </StyledTableCellBodyBold>
                                  </StyledTableRow>
                                  {key + 1 === transaction?.orders?.length && (
                                    <React.Fragment>
                                      <StyledTableRow>
                                        <StyledTableCellBodyBold
                                          style={{
                                            fontSize: "larger",
                                          }}
                                        >
                                          Shop Amount
                                        </StyledTableCellBodyBold>
                                        <StyledTableCellBodyBold
                                          align="right"
                                          style={{
                                            fontSize: "larger",
                                          }}
                                        >
                                          {formatCurrency(
                                            transaction?.orders[0]?.tenant
                                              ?.property?.currency,
                                            (
                                              transaction?.total_amount -
                                              (transaction?.fee?.total
                                                ? transaction?.fee?.total
                                                : 0)
                                            ).toString()
                                          )}
                                        </StyledTableCellBodyBold>
                                      </StyledTableRow>
                                      {transaction?.fee?.total && (
                                        <StyledTableRow>
                                          <StyledTableCellBodyBold
                                            style={{
                                              fontSize: "larger",
                                            }}
                                          >
                                            {transaction?.fee?.name}
                                          </StyledTableCellBodyBold>
                                          <StyledTableCellBodyBold
                                            align="right"
                                            style={{
                                              fontSize: "larger",
                                            }}
                                          >
                                            {formatCurrency(
                                              transaction?.orders[0]?.tenant
                                                ?.property?.currency,
                                              (transaction?.fee?.total).toString()
                                            )}
                                          </StyledTableCellBodyBold>
                                        </StyledTableRow>
                                      )}
                                      <StyledTableRow>
                                        <StyledTableCellBodyBold
                                          style={{
                                            fontSize: "larger",
                                          }}
                                        >
                                          TOTAL
                                        </StyledTableCellBodyBold>
                                        <StyledTableCellBodyBold
                                          align="right"
                                          style={{
                                            fontSize: "larger",
                                          }}
                                        >
                                          {formatCurrency(
                                            transaction?.orders[0]?.tenant
                                              ?.property?.currency,
                                            (transaction?.total_amount).toString()
                                          )}
                                        </StyledTableCellBodyBold>
                                      </StyledTableRow>
                                    </React.Fragment>
                                  )}
                                </TableBody>
                              </StyledTable>
                            </Box>
                          </div>
                        );
                      })}
                      <div ref={bottomDiv} />
                    </div>
                  )}

                  {transaction?.complete &&
                    parseInt(transaction?.pickup?.id) > 0 && (
                      <Alert severity="error" style={{ marginTop: 25 }}>
                        Unable to update order data. Updating order to complete
                        only when all order status is ready for pickup.
                      </Alert>
                    )}

                  {parseInt(transaction?.delivery?.id) > 0 &&
                    transaction?.delivery?.delivery_status !== "delivering" && (
                      <Alert severity="error" style={{ marginTop: 25 }}>
                        Unable to update order data. Updating transaction to
                        complete only when delivery status is complete delivery.
                      </Alert>
                    )}
                </div>
              )}
              {!transaction && qrString !== null && (
                <Alert severity="error" style={{ marginTop: 25 }}>
                  Transaction not found
                </Alert>
              )}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      {!loading &&
        ((!transaction?.complete && parseInt(transaction?.pickup?.id) > 0) ||
          (!transaction?.complete &&
            parseInt(transaction?.delivery?.id) > 0 &&
            transaction?.delivery?.delivery_status === "delivering")) && (
          <DialogActions>
            <div className="btn-wrapper">
              <Button
                type="button"
                variant="contained"
                style={{ margin: "0 auto", width: "100%" }}
                color="primary"
                disabled={
                  updating ||
                  updated ||
                  transaction?.complete ||
                  transaction?.delivery?.delivery_status === "wait"
                }
                onClick={handleUpdateProgress}
              >
                Complete
              </Button>
              {updating && (
                <CircularProgress size={24} className="btn-progress" />
              )}
            </div>
          </DialogActions>
        )}
    </CustomizedDialogs>
  );
};

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function scannerFormComplete(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
